module.exports = __webpack_public_path__ + "24352b98b4e8679dfc744258c0f310f1.MP3";